module.exports = __webpack_public_path__ + "img/python.067050f6.png";